import React from 'react';
import { Accordion } from '../ui';

const FAQ_ITEMS = [
  {
    q: 'Wie schnell erhalte ich Benachrichtigungen?',
    a: 'Unser System überprüft alle Immobilienportale alle 5–10 Minuten. Du erhältst eine Benachrichtigung normalerweise innerhalb von 5 Minuten nach Veröffentlichung einer neuen Wohnung.',
  },
  {
    q: 'Welche Immobilienportale werden überwacht?',
    a: 'Wir überwachen über 20 Portale, darunter Immoscout24, Immowelt, eBay Kleinanzeigen, Immonet, Wohnungsboerse.net und viele weitere regionale Anbieter.',
  },
  {
    q: 'Kann ich mehrere Städte gleichzeitig überwachen?',
    a: 'Mit dem Premium-Plan kannst du bis zu 10 verschiedene PLZ-Bereiche gleichzeitig überwachen. Der kostenlose Plan erlaubt 1 PLZ-Bereich.',
  },
  {
    q: 'Wie funktioniert die Bezahlung?',
    a: 'Wir nutzen Stripe für sichere Zahlungen. Du wählst ein Paket (1, 3, 6 oder 12 Monate), zahlst einmalig und erhältst sofortigen Zugang. Keine automatische Verlängerung, keine versteckten Kosten.',
  },
  {
    q: 'Ist meine Privatsphäre geschützt?',
    a: 'Absolut! Wir speichern nur deine Telegram-ID oder E-Mail-Adresse und deine Suchkriterien. Keine persönlichen Daten, keine Weitergabe an Dritte. Alle Server stehen in Deutschland und sind DSGVO-konform.',
  },
  {
    q: 'Muss ich etwas kündigen?',
    a: 'Nein! Es gibt keine automatische Verlängerung und daher nichts zu kündigen. Dein Paket läuft nach dem gebuchten Zeitraum einfach aus und dein Account wird automatisch auf Free zurückgestuft. Wenn du den Dienst gar nicht mehr nutzen möchtest, kannst du dein Konto jederzeit in den Einstellungen löschen.',
  },
];

/** The 6 questions/answers from the previous landing page, reused verbatim and rewritten to "du". */
export const Faq: React.FC = () => (
  <section id="faq" className="scroll-mt-20 border-b border-line bg-page py-16 md:py-24">
    <div className="mx-auto w-full max-w-wide px-4 md:px-6">
      <h2 className="font-display text-2xl text-ink md:text-3xl">Häufig gestellte Fragen</h2>

      <div className="mt-8 max-w-narrow">
        {FAQ_ITEMS.map((item) => (
          <Accordion key={item.q} title={item.q} className="faq-item">
            <p>{item.a}</p>
          </Accordion>
        ))}
      </div>
    </div>
  </section>
);

export default Faq;
